// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xlh6NqHA_ERyTV80IR7B {
  display: contents;
}
.Xlh6NqHA_ERyTV80IR7B td:not(.d) .fileicon {
  background: none !important;
}
.Xlh6NqHA_ERyTV80IR7B td:not(.d) .fileicon::before {
  font-family: 'Material Symbols Outlined' !important;
  opacity: 0.6;
  font-size: 1rem !important;
  content: 'cloud_upload' !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Xlh6NqHA_ERyTV80IR7B`,
	"d": `d`,
	"fileicon": `fileicon`
};
export default ___CSS_LOADER_EXPORT___;
